import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    currentPage: "",
    currentTub: {
      rbxtree: "topups",
      rbxpier: "topups",
      rbxsea: "topups"
    },
    admin_key: "",
    openBurgerMenu: false,
    isOpenSearch: true,
    isOpenExitPopup: false,
    isOpenUserSearch: false,
    isOpenPaymentSearch: false,
    isOpenCookieChecker: false,
    isOpenMobileFilter: false,
    isOpenMobileFilterUserPayment: false,
    toggleSite: "rbxtree",
    // Режим Макса: на каких проектах введён ключ изменяющих ручек (сами ключи — в sessionStorage)
    privilegedSites: { rbxtree: false, rbxpier: false },
    isOpenPrivilegedLogin: false,
    balanceTarget: null,
    isOpenBulkRefund: false,
    // ID заказа, который надо найти на вкладке после перехода из пополнений
    pendingOrderSearch: null
  },
  mutations: {
    setKey(state, key) {
      state.admin_key = key;
    },
    setPrivilegedSites(state, sites) {
      state.privilegedSites = { ...state.privilegedSites, ...sites };
    }
  },
  actions: {},
  modules: {}
});
